import catalogEn from "./catalog.en";
import inventoryEn from "./inventory.en";
import customersEn from "./customers.en";
import taxEn from "./tax.en";
import discountsEn from "./discounts.en";
import shippingEn from "./shipping.en";
import checkoutEn from "./checkout.en";
import themesEn from "./themes.en";
import contentEn from "./content.en";
import domainsEn from "./domains.en";
import searchEn from "./search.en";
import codeEn from "./code.en";
import veEn from "./ve.en";
import aiEn from "./ai.en";
import locEn from "./loc.en";
import redesignEn from "./redesign.en";
import ordersEn from "./orders.en";
import paymentsEn from "./payments.en";
import couriersEn from "./couriers.en";
import invoicesEn from "./invoices.en";
import billingEn from "./billing.en";
import featuresEn from "./features.en";
import whatsappEn from "./whatsapp.en";
import engageEn from "./engage.en";
import analyticsEn from "./analytics.en";
import marketingEn from "./marketing.en";
import giftCardsEn from "./giftcards.en";
import appsEn from "./apps.en";
import platformEn from "./platform.en";
import sampleEn from "./sample.en";
import overviewEn from "./overview.en";

const en = {
  ...catalogEn,
  ...inventoryEn,
  ...customersEn,
  ...taxEn,
  ...discountsEn,
  ...shippingEn,
  ...checkoutEn,
  ...paymentsEn,
  ...couriersEn,
  ...invoicesEn,
  ...billingEn,
  ...featuresEn,
  ...whatsappEn,
  ...appsEn,
  ...platformEn,
  ...sampleEn,
  ...overviewEn,
  ...engageEn,
  ...analyticsEn,
  ...marketingEn,
  ...giftCardsEn,
  ...ordersEn,
  ...themesEn,
  ...contentEn,
  ...domainsEn,
  ...searchEn,
  ...codeEn,
  ...veEn,
  ...aiEn,
  ...locEn,
  ...redesignEn,
  "app.name": "Sooquna",
  "common.save": "Save",
  "common.discard": "Discard",
  "common.cancel": "Cancel",
  "common.continue": "Continue",
  "common.leave_title": "Leave this page?",
  "common.leave": "Leave page",
  "security.stepup_title": "Confirm it's you",
  "security.stepup_body": "This action needs a recent sign-in with two-step verification. You'll sign in again, then come straight back here.",
  "security.stepup_action": "Sign in again",
  "security.mfa_title": "Turn on two-step verification",
  "security.mfa_body": "To protect your store, this action is only available once two-step verification is on for your account.",
  "security.mfa_action": "Open account security",
  "common.back": "Back",
  "common.loading": "Loading…",
  "common.retry": "Try again",
  "common.error": "Something went wrong.",
  "common.saved": "Saved",
  "common.delete": "Delete",
  "common.remove": "Remove",
  "common.search": "Search",
  "common.none": "None",
  "common.unsaved": "Unsaved changes",
  "common.leave_confirm": "You have unsaved changes. Leave this page?",
  "common.coming_soon": "Coming soon",
  "common.optional": "optional",
  "common.copy": "Copy",
  "common.language": "Language",

  "user.account": "Account settings",
  "user.logout": "Log out",
  "user.stores": "All stores",

  "chooser.title": "Your stores",
  "chooser.search": "Search stores",
  "chooser.create": "Create store",
  "chooser.empty_title": "You don't have any stores yet",
  "chooser.empty_body": "Create your first store to start selling. It takes about a minute.",
  "chooser.role.owner": "Owner",
  "chooser.role.staff": "Staff",
  "chooser.role.collaborator": "Collaborator",
  "chooser.development": "Development",
  "chooser.partner_dashboard": "Partner dashboard",
  "chooser.last_opened": "Opened {when}",
  "chooser.load_more": "Load more",

  "onboarding.title": "Tell us about you",
  "onboarding.subtitle": "This helps us set things up for you.",
  "onboarding.type": "I'm joining as",
  "onboarding.merchant": "A merchant",
  "onboarding.merchant_hint": "I want to sell online",
  "onboarding.partner": "A partner",
  "onboarding.partner_hint": "I build stores for clients",
  "onboarding.name": "Your name",
  "onboarding.country": "Country",
  "onboarding.phone": "Phone",
  "onboarding.selling_now": "Are you selling already?",
  "onboarding.yes": "Yes",
  "onboarding.no": "Not yet",
  "onboarding.industry": "What do you sell?",
  "onboarding.company": "Company name",
  "onboarding.website": "Website",
  "onboarding.services": "Services you offer",
  "onboarding.service.theme_development": "Theme development",
  "onboarding.service.store_setup": "Store setup",
  "onboarding.service.marketing": "Marketing",
  "onboarding.service.integrations": "Integrations",
  "onboarding.agreement": "I accept the partner program agreement",

  "create.title": "Create your store",
  "create.step": "Step {n} of {total}",
  "create.name": "Store name",
  "create.name_hint": "You can change this later.",
  "create.country": "Where is your business based?",
  "create.currency": "Store currency",
  "create.currency_hint": "Prices are shown in this currency. It can't be changed after your first order.",
  "create.languages": "Store languages",
  "create.look": "Pick a colour",
  "create.look_hint": "Used for your storefront and emails. Themes come later.",
  "create.demo": "Add sample products so I can see how it looks",
  "create.submit": "Create store",
  "create.provisioning": "Setting up {name}",
  "create.provisioning_hint": "This usually takes a few seconds.",
  "create.step.domain": "Reserving your address",
  "create.step.subscription": "Starting your free trial",
  "create.step.activate": "Opening your store",
  "create.step.other": "Preparing",
  "create.failed_step": "Retrying…",
  "create.ready": "Your store is ready",
  "create.open": "Go to your store",

  "nav.collections": "Collections",
  "settings.custom_data": "Custom fields",
  "settings.custom_data_hint": "Custom fields and content types",
  "nav.home": "Overview",
  "nav.orders": "Orders",
  "nav.products": "Products",
  "nav.customers": "Customers",
  "nav.content": "Content",
  "nav.analytics": "Analytics",
  "nav.marketing": "Campaigns",
  "nav.discounts": "Discounts",
  "nav.online_store": "Storefront",
  "nav.settings": "Settings",
  "nav.view_store": "View store",
  "nav.menu": "Menu",

  "bell.title": "Notifications",
  "bell.empty": "You're all caught up.",
  "bell.mark_all": "Mark all as read",

  "trial.banner": "Your free trial ends in {days} days.",
  "trial.banner_today": "Your free trial ends today.",
  "trial.banner_ended": "Your free trial has ended.",
  "trial.choose_plan": "Choose a plan",
  "dev.banner": "This is a development store. Transfer it to your client to launch.",

  "home.greeting": "Welcome, {name}",
  "home.guide": "Set up your store",
  "home.guide_progress": "{done} of {total} tasks complete",
  "home.guide_dismiss": "Hide guide",
  "home.guide_show": "Show setup guide",
  "home.guide.add_product": "Add your first product",
  "home.guide.customize_theme": "Customize your storefront",
  "home.guide.add_domain": "Add a custom domain",
  "home.guide.setup_payments": "Set up payments",
  "home.guide.setup_shipping": "Set up shipping",
  "home.guide.review_policies": "Review your policies",
  "home.guide.test_order": "Place a test order",
  "home.guide.launch": "Launch your store",
  "home.storefront": "Your storefront",
  "home.password_protected": "Password protected until you launch",
  "home.kpis_soon": "Sales, orders and visitors will appear here once you start selling.",

  "launch.title": "Launch",
  "launch.ready": "Everything is ready. Launching removes your storefront password.",
  "launch.blocked": "Before you can launch:",
  "launch.button": "Launch store",
  "launch.blocker.development_store": "Development stores launch after they're transferred to a client.",
  "launch.blocker.already_launched": "Your store is already live.",
  "launch.blocker.plan_required": "Choose a paid plan.",
  "launch.blocker.email_verified": "Verify your email address.",
  "launch.blocker.store_details": "Add your legal business name and contact email.",
  "launch.blocker.payments": "Set up a payment method.",
  "launch.blocker.shipping": "Set up shipping.",
  "launch.blocker.policies": "Add your store policies.",
  "launch.blocker.payments_unavailable": "Payments setup isn't available yet.",
  "launch.blocker.shipping_unavailable": "Shipping setup isn't available yet.",
  "launch.blocker.policies_unavailable": "Policies setup isn't available yet.",

  "settings.title": "Settings",
  "settings.general": "Store profile",
  "settings.general_hint": "Store details, contact, formats",
  "settings.plan": "Subscription",
  "settings.plan_hint": "Your plan and trial",
  "settings.users": "Team & roles",
  "settings.users_hint": "Staff, roles and collaborators",
  "settings.notifications": "Notifications",
  "settings.notifications_hint": "Emails sent to you and your customers",
  "settings.files": "Files",
  "settings.files_hint": "Images, videos and documents",
  "settings.activity": "Activity log",
  "settings.activity_hint": "Who changed what, and when",
  "settings.status": "Store status",
  "settings.status_hint": "Launch, transfer",
  "settings.other": "Regions & currencies and more arrive in later releases.",

  "general.details": "Store details",
  "general.name": "Store name",
  "general.legal_name": "Legal business name",
  "general.tax_no": "Tax registration number",
  "general.contact_email": "Contact email",
  "general.sender_name": "Sender name",
  "general.phone": "Support phone",
  "general.formats": "Standards and formats",
  "general.timezone": "Time zone",
  "general.unit_system": "Unit system",
  "general.metric": "Metric",
  "general.imperial": "Imperial",
  "general.weight_unit": "Default weight unit",
  "general.currency": "Store currency",
  "general.order_ids": "Order ID",
  "general.prefix": "Prefix",
  "general.suffix": "Suffix",
  "general.conflict": "Someone else changed these settings. Reload to see their changes.",

  "plan.current": "Current plan",
  "plan.trial_until": "Free trial until {date}",
  "plan.development": "Development store: free while you build",
  "plan.per_month": "{price}/month",
  "plan.staff": "{n} staff accounts",
  "plan.storage": "{n} GB file storage",
  "plan.enterprise": "Enterprise",
  "plan.enterprise_price": "Custom pricing",
  "plan.enterprise_body": "Limits, pricing and support set for high-volume brands and groups.",
  "plan.enterprise_cta": "Get a quote",
  "plan.paid_soon": "Paid plans and billing open soon. Your store keeps working during the trial.",

  "users.owner": "Store owner",
  "users.staff": "Staff",
  "users.invite": "Add staff",
  "users.invite_title": "Add staff",
  "users.email": "Email",
  "users.role": "Role",
  "users.pending": "Pending invitations",
  "users.expires": "Expires {date}",
  "users.revoke": "Revoke",
  "users.remove_confirm": "Remove {name}? They lose access immediately.",
  "users.collaborators": "Collaborators",
  "users.requests": "Collaborator requests",
  "users.approve": "Approve",
  "users.decline": "Decline",
  "users.request_from": "{partner} requests access",
  "users.mfa": "2-step on",
  "users.no_mfa": "2-step off",
  "users.transfer": "Transfer to client",
  "users.transfer_hint": "Send this development store to your client. They become the owner and start a trial.",
  "users.transfer_email": "Client's email",
  "users.transfer_keep": "Keep collaborator access after the transfer",
  "users.transfer_sent": "Transfer request sent.",
  "export.store_title": "Export store data",
  "export.store_hint": "Download everything in your store as one zip file: products, customers, orders, content, settings and the activity log, as JSON and CSV. Passwords, access tokens and payment keys are not included.",
  "export.store_start": "Prepare export",
  "export.store_preparing": "Preparing your export ({done} of {total})…",
  "export.store_failed": "The export couldn't be prepared. Try again.",
  "collab.title": "Approve collaborator access",
  "collab.step_review": "Review request",
  "collab.step_access": "Set access",
  "collab.step_confirm": "Confirm",
  "collab.intro": "{partner} wants collaborator access to this store.",
  "collab.message": "Their message",
  "collab.permissions": "Requested permissions ({n})",
  "collab.no_permissions": "No permissions requested.",
  "collab.duration": "When should access end?",
  "collab.never": "Keep access until I remove it",
  "collab.days": "After {n} days",
  "collab.custom": "On a specific date",
  "collab.date": "End date",
  "collab.summary": "{partner} will get {n} permissions on this store.",
  "collab.summary_until": "Access ends automatically on {date}.",
  "collab.summary_forever": "Access stays until you remove them in Users and permissions.",
  "collab.security_note": "You may be asked to confirm your identity before access is granted.",
  "collab.resumed": "Identity confirmed. Grant access to finish.",
  "collab.grant": "Grant access",
  "collab.granted": "{partner} now has collaborator access.",
  "collab.decline_title": "Decline {partner}'s request?",
  "collab.decline_body": "They won't get access to this store. They can send a new request later.",
  "collab.declined": "Request declined.",
  "users.remove_title": "Remove {name}?",
  "users.remove_body": "They lose access to this store immediately.",

  "notif.store_emails": "Emails to you",
  "notif.log": "Message log",
  "notif.type.trial_ending": "Trial ending reminders",
  "notif.type.trial_ended": "Trial ended",
  "notif.type.collaborator_request": "Collaborator requests",
  "notif.type.transfer_accepted": "Store transfer accepted",
  "notif.type.invoice_issued": "Invoices to customers",
  "notif.type.shipping_update": "Shipping updates to customers",
  "notif.type.out_for_delivery": "Out for delivery (customers)",
  "notif.type.delivered": "Delivered (customers)",
  "notif.status.queued": "Queued",
  "notif.status.sent": "Sent",
  "notif.status.delivered": "Delivered",
  "notif.status.bounced": "Bounced",
  "notif.status.complained": "Marked as spam",
  "notif.status.failed": "Failed",
  "notif.status.suppressed": "Not sent (suppressed)",

  "files.title": "Files",
  "files.upload": "Upload files",
  "files.drop": "Drop files to upload",
  "files.storage": "{used} of {quota} used",
  "files.uploading": "Uploading {name}",
  "files.processing": "Processing",
  "files.failed": "Failed",
  "files.delete_confirm": "Delete {name}? This can't be undone.",
  "files.in_use": "This file is used and can't be deleted.",
  "files.empty": "Upload images, videos and documents to use them across your store.",
  "files.alt": "Alt text",
  "files.copy_link": "Copy link",
  "files.copied": "Link copied",

  "activity.title": "Activity log",
  "activity.empty": "No activity yet.",
  "activity.by": "by {actor}",
  "activity.load_more": "Load more",

  "partner.title": "Partner dashboard",
  "partner.pending": "Your partner application is under review. You can already build development stores.",
  "partner.stores": "Stores",
  "partner.dev_store": "Create development store",
  "partner.request": "Request access to a store",
  "partner.store_domain": "Store address",
  "partner.permissions": "Permissions",
  "partner.message": "Message to the owner",
  "partner.send_request": "Send request",
  "partner.requests": "Access requests",
  "partner.transfers": "Transfers",
  "partner.earnings": "Earnings",
  "partner.earnings_soon": "Revenue share is paid once stores you referred are on paid plans.",
  "partner.referral": "Referral code",

  "accept.transfer_title": "Accept store",
  "accept.transfer_body": "You've been offered ownership of a store. Accepting makes you its owner and starts a free trial.",
  "accept.accept": "Accept",
  "accept.invite_title": "Join team",
  "accept.invite_body": "Accept the invitation to join this team.",
  "common.add": "Add",
  "richtext.link": "Insert link",
  "richtext.insert_link": "Insert link",
  "richtext.link_url": "Link to",
  "richtext.link_hint": "A web address (https://…), email (mailto:…), phone (tel:…) or a store path (/pages/…)",
  "content.metaobjects": "Custom content",
  "content.manage_definitions": "Manage definitions",
  "content.metaobjects_empty": "No content types yet",
  "content.metaobjects_empty_body": "Define structured content like size charts or FAQs, then add entries here.",
  "content.col.definition": "Definition",
  "content.col.entries": "Entries",
  "settings.customer_privacy": "Customer privacy",
  "settings.customer_privacy_hint": "Data requests from customers: exports and erasures",
  "nav.metaobjects": "Custom content",
  "nav.files": "Files",
  "nav.gift_cards": "Gift cards",
  "nav.drafts": "Manual orders",
  "nav.abandoned": "Recovered carts",
} as const;

export type Key = keyof typeof en;
export default en as Record<Key, string>;
